import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const PageService = {
  // Define your API functions here
  create: async (data) => {
    const response = await apiService.post("/pages", data);
    return response.data;
  },
  checkSlug: async (data) => {
    const response = await apiService.post("/pages/check-slug", data);
    return response.data;
  },
  update: async (id, updatedData) => {
    try {
      const response = await apiService.put(`/pages/${id}`, updatedData);
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  getList: async ({ search = "", page = 1, pageSize = 10, isOnshorePage }) => {
    const params = new URLSearchParams({
      ...(search && { search }),

      ...(isOnshorePage !== null &&
        isOnshorePage !== undefined && {
          isOnshorePage: String(isOnshorePage),
        }),

      page: page.toString(),
      pageSize: pageSize.toString(),
    });

    const response = await apiService.get(`/pages?${params.toString()}`);
    return response.data;
  },

  getIntellList: async ({ search = "", page = 1, pageSize = 10 }) => {
    const params = new URLSearchParams({
      ...(search && { search }),
      page: page.toString(),
      pageSize: pageSize.toString(),
    });

    const response = await apiService.get(
      `/pages/intelligent-section?${params.toString()}`,
    );
    return response.data;
  },
  getDetail: async (id) => {
    const response = await apiService.get(`/pages/${id}`);
    return response.data;
  },
  getBySlug: async (id) => {
    const response = await apiService.get(`/pages/slug?slug=${id}`);
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(`/pages/${id}`);
    return response.data;
  },
};

export default PageService;
